import { memo } from "react";
import { IMinerFlagProps } from "./MinerFlag.props";
import cn from "classnames";
import { Button, Tooltip } from "antd";
import { FlagColorType, useMinerFlagControl } from "./useMinerFlagControl";
import { useIntl } from "react-intl";
import { Segmented } from "antd";
import Icon from "../Icon/Icon";

import flag_red from "@assets/icons/flag_red.svg";
import flag_green from "@assets/icons/flag_green.svg";
import flag_yellow from "@assets/icons/flag_yellow.svg";
import flag_orange from "@assets/icons/flag_orange.svg";
import flag_black from "@assets/icons/flag_black.svg";
import flag_violet from "@assets/icons/flag_violet.svg";
import close from "@assets/icons/close.svg";

import styles from "./MinerFlag.module.scss";

const renderFlag = (code: FlagColorType) => {
  switch (code) {
    case "green":
      return flag_green;
    case "yellow":
      return flag_yellow;
    case "red":
      return flag_red;
    case "orange":
      return flag_orange;
    case "violet":
      return flag_violet;
    default:
      return flag_black;
  }
};

const flags: { value: FlagColorType; src: string }[] = [
  {
    value: "green",
    src: flag_green,
  },
  {
    value: "yellow",
    src: flag_yellow,
  },

  {
    value: "orange",
    src: flag_orange,
  },

  {
    value: "violet",
    src: flag_violet,
  },

  {
    value: "red",
    src: flag_red,
  },
];

function MinerFlag(props: IMinerFlagProps) {
  const { formatMessage } = useIntl();
  const control = useMinerFlagControl(props);

  return (
    <Tooltip
      open={control.open}
      title={
        <div className={styles.text_wrapper} tabIndex={100}>
          <Segmented
            className={styles.flags}
            onChange={(v) => control.onChangeColor(v as FlagColorType)}
            value={control.color}
            onClick={(e) => e.stopPropagation()}
            options={flags.map((flag) => ({
              value: flag.value,
              label: (
                <div className={styles.flag_item}>
                  <div className={cn(styles.wrapper)}>
                    <Icon src={flag.src} className={styles.flag} noHover />
                  </div>
                </div>
              ),
            }))}
          />
          <div className={styles.area_wrapper}>
            <textarea
              ref={control.ref}
              value={control.text}
              onChange={(e) => control.setText(e.target.value)}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={control.onSaveByKeydown}
              onBlur={(e) => console.log(e)}
              tabIndex={-1}
            />
            {!control.text && control.text.length > 0 && (
              <Icon
                src={close}
                className={styles.close}
                onClick={control.onCancel}
                noHover
              />
            )}
          </div>
          <div className={styles.bottom}>
            <div className={styles.btns}>
              <Button
                className={styles.btn}
                size="small"
                loading={control.loading}
                onClick={control.onSave}
              >
                {formatMessage({ id: "modal.pool.btn.save" })}
              </Button>
              {control.isActive && (
                <Button
                  className={cn(styles.btn, styles.btn__cancel)}
                  size="small"
                  loading={control.loading}
                  onClick={control.onDelete}
                >
                  {formatMessage({ id: "machines.table.tabs.delete" })}
                </Button>
              )}
            </div>
          </div>
        </div>
      }
      color="white"
      placement="right"
      destroyOnHidden
      trigger={"click"}
      afterOpenChange={control.afterOpenChanged}
      styles={{ body: { width: 300 } }}
    >
      <div
        className={cn(
          styles.wrapper,
          props.className,
          !control.isActive && props.optionalClassName
        )}
      >
        <Icon
          className={styles.flag}
          src={renderFlag(control.color)}
          title={control.text}
          noHover
        />
      </div>
    </Tooltip>
  );
}
export default MinerFlag;

// memo(
//   MinerFlag,
//   (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
// );
